(function() {
  // Arkana Hero Banner Fix - JavaScript Loader
  // Ensures background-position: center is applied
  
  function applyArkanaHeroFix() {
    const arkanaElements = document.querySelectorAll(
      '[data-brand="arkana"] .slideshow, '
      + '[data-brand="arkana"] .hero-section, '
      + '[data-brand="arkana"] .hero-banner, '
      + '.slideshow[data-arkana="true"], '
      + '.hero[data-arkana="true"]'
    );
    
    arkanaElements.forEach(function(el) {
      el.style.backgroundSize = 'cover';
      el.style.backgroundPosition = 'center';
      el.style.backgroundRepeat = 'no-repeat';
      
      // Set min-height based on viewport
      if (window.innerWidth >= 769) {
        el.style.minHeight = '770px';
      } else {
        el.style.minHeight = '700px';
      }
    });
  }
  
  // Apply on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyArkanaHeroFix);
  } else {
    applyArkanaHeroFix();
  }
  
  // Reapply after any dynamic content changes
  window.addEventListener('load', applyArkanaHeroFix);
  setTimeout(applyArkanaHeroFix, 500);
  setTimeout(applyArkanaHeroFix, 1000);
})();